function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 3689",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3588",
  d: "M4.655 33.932a4.5 4.5 0 00.035 6.315l31.521 31.946a4.462 4.462 0 006.314-.037 4.5 4.5 0 00-.037-6.312L10.967 33.896a4.458 4.458 0 00-6.312.036z",
  fill: "#eae8e5",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3589",
  d: "M60.365 91.486l-24.221 4.731-3.72-19.028-17.032-24.592 36-7.031z",
  fill: "#eae8e5",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3590",
  d: "M5.083 48.288a4.5 4.5 0 00.036 6.313l31.522 31.947a4.459 4.459 0 006.314-.037 4.5 4.5 0 00-.037-6.313L11.397 48.252a4.457 4.457 0 00-6.314.036z",
  fill: "#eae8e5",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3591",
  d: "M1.692 16.342a4.5 4.5 0 00.036 6.313l30.371 30.743a4.456 4.456 0 006.313-.036 4.493 4.493 0 00-.037-6.312L8.006 16.306a4.457 4.457 0 00-6.314.036z",
  fill: "#eae8e5",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 2239",
  transform: "translate(10.056)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rettangolo 2008",
  width: 37.628,
  height: 68.005,
  rx: 5,
  fill: "#a5a093"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rettangolo 2009",
  d: "M3.557 6.219h30.514a.248.248 0 01.248.248v54.452a.247.247 0 01-.247.247H3.557a.247.247 0 01-.247-.247V6.466a.247.247 0 01.247-.247z",
  fill: "#eae8e5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rettangolo 2010",
  d: "M13.11 1.835h11.408a.563.563 0 01.563.563.562.562 0 01-.562.562h-11.41a.562.562 0 01-.562-.562.563.563 0 01.563-.563z",
  fill: "#dbd7d0"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3592",
  d: "M18.814 62.578a1.9 1.9 0 101.9 1.9 1.9 1.9 0 00-1.9-1.9z",
  fill: "#dbd7d0",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3593",
  d: "M2.126 45.353a4.483 4.483 0 00.035 6.313l5.915 5.873a4.476 4.476 0 006.313-.036 4.48 4.48 0 00-.036-6.313L8.44 45.316a4.473 4.473 0 00-6.314.037z",
  fill: "#eae8e5",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3594",
  d: "M1.281 30.585a4.481 4.481 0 00.035 6.312l5.037 5a4.477 4.477 0 006.313-.035 4.479 4.479 0 00-.036-6.312l-5.037-5a4.469 4.469 0 00-6.312.035z",
  fill: "#eae8e5",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3595",
  d: "M62.134 83.577l-30.6 5.978 1.369 11.988a65.094 65.094 0 0031.021-8.827z",
  fill: "#9e998f",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3596",
  d: "M53.694 73.025l-3.095.6-.412-3.9-3.32-31.267c-.562-5.295 2.108-7.42 5.3-8.452 1.76-.568 2.18-1.056 2.351.558l3.8 35.789a6.141 6.141 0 01-4.624 6.672z",
  fill: "#eae8e5",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Raggruppa 2240",
  fill: "#a5a093"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3597",
  d: "M27.718 28.204a.277.277 0 00-.3.041l-2.393 2.054h-2.368a.278.278 0 00-.279.278v3.229a.278.278 0 00.279.279h2.221l2.546 2.056a.281.281 0 00.177.063.27.27 0 00.119-.028.277.277 0 00.16-.253v-7.464a.275.275 0 00-.162-.255z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3598",
  d: "M28.981 29.802a.28.28 0 00-.046.393 3.3 3.3 0 010 3.992.278.278 0 00.046.392.267.267 0 00.173.062.277.277 0 00.219-.107 3.867 3.867 0 000-4.685.28.28 0 00-.392-.047z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3599",
  d: "M31.052 28.786a.282.282 0 00-.062.393 5.235 5.235 0 010 6.025.278.278 0 00.062.39.287.287 0 00.165.054.279.279 0 00.226-.115 5.9 5.9 0 000-6.685.282.282 0 00-.391-.062z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Tracciato 3600",
  d: "M32.909 27.17a.278.278 0 00-.066.389c.034.048 3.252 4.684 0 9.26a.282.282 0 00.066.392.276.276 0 00.162.05.28.28 0 00.229-.116c3.479-4.9.035-9.858 0-9.908a.281.281 0 00-.391-.067z"
})));

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.92 101.543"
  }, props), _ref);
}

export default SvgPhone;